import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=19f89d0c&scoped=true&"
import script from "./tree.vue?vue&type=script&lang=js&"
export * from "./tree.vue?vue&type=script&lang=js&"
import style0 from "./tree.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./tree.vue?vue&type=style&index=1&id=19f89d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f89d0c",
  null
  
)

component.options.__file = "tree.vue"
export default component.exports